












// @ is an alias to /src
import { Component, Vue } from 'vue-property-decorator'
import EditBaseFlux from '@/components/flux/edit/EditBaseFlux.vue'
import deepEqual from 'deep-equal'
import cloneDeep from 'clone-deep'
import { AloFlux, getDefaultAloFlux } from '@/models/alo/AloFlux'
import { toSubArray } from '@/utils/groupBy'

@Component({
  name: 'EditPartenaires',    
  components:{EditBaseFlux}
})
export default class EditPartenaires extends Vue {
  
  private flux = getDefaultAloFlux()
  
  edit(item:AloFlux) {    
    this.flux = (this.$refs.baseEdit as EditBaseFlux).edit(item)
  }  

  get partenaireList() {
    //@ts-ignore    
    return this.$store.myGetters.partenaireList
  }

  get partenaireGroup(){
    return toSubArray(this.partenaireList,3)
  }  
}
